import React from "react";
import { useState, useEffect } from "react";
import { Table, Radio, Modal, Typography } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../utils/routes.js";

import { FirmUsersColumns } from "./FirmUsersColumns.js";
import useFirmService from "../../../services/useFirmService.js";
import useAuth from "../../../hooks/useAuth.js";
const { Title } = Typography;

const FirmUsers = () => {
  const [tableData, setTableData] = useState([]);
  const { useGetFirmUsers } = useFirmService();
  const { data: firmUsers, isLoading: tableLoading } = useGetFirmUsers();
  const { firmAuth } = useAuth();
  console.log("firm auth is", firmAuth);
  const isAdmin = firmAuth.user.firmRole.name === "ADMIN";

  const navigate = useNavigate();

  useEffect(() => {
    setTableData(
      firmUsers?.data?.map((item) => {
        return { key: item.firmUserId, ...item };
      })
    );
  }, [firmUsers]);

  const goToUpdatePage = ({ record }) => {
    const firmUserId = record.firmUserId;
    let path = `${PageRoutes.updateFirmUser}/${firmUserId}`;
    navigate(path);
  };

  const deleteApplicationStatus = ({ record }) => {};

  return (
    <>
      <div
        style={{
          display: "flex",
          margin: "auto",
          marginBottom: 20,
          justifyContent: "center",
        }}>
        <Title level={3}>Firma Kullanıcıları</Title>
      </div>

      <Table
        bordered={true}
        pagination={false}
        dataSource={tableData}
        columns={FirmUsersColumns(
          goToUpdatePage,
          deleteApplicationStatus,
          isAdmin
        )}
        scroll={{ x: true }}
        loading={tableLoading}
      />
    </>
  );
};

export default FirmUsers;
